import {ArrowTopRightOnSquareIcon} from "@heroicons/react/20/solid";
import {OtsActionLink} from "../components/OtsButton";
import {OtsMobileApp} from "./ots-mobile-apps";

export type OtsMobileAppCardProps = {
  app: OtsMobileApp;
  className?: string;
};

/** One mobile app with its App Store and Google Play links. */
export const OtsMobileAppCard = ({app, className}: OtsMobileAppCardProps) => (
  <article
    aria-label={app.name}
    className={[
      "flex flex-wrap items-center justify-between gap-4 rounded-lg border border-[var(--ots-outline-variant)] bg-[var(--ots-surface)] p-4 sm:p-5",
      className
    ].filter(Boolean).join(" ")}>
    <div className="flex min-w-0 items-center gap-3">
      <img src={app.logo} alt="" className="size-11 shrink-0 rounded-xl object-contain"/>
      <h3 className="truncate font-[family-name:var(--ots-font-display)] text-base font-semibold text-[var(--ots-secondary)]">
        {app.name}
      </h3>
    </div>
    <div className="flex flex-wrap gap-2">
      <OtsActionLink
        size="compact"
        href={app.ios}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${app.name} on the App Store (opens in a new tab)`}
        trailingIcon={<ArrowTopRightOnSquareIcon/>}>
        App Store
      </OtsActionLink>
      <OtsActionLink
        size="compact"
        href={app.android}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${app.name} on Google Play (opens in a new tab)`}
        trailingIcon={<ArrowTopRightOnSquareIcon/>}>
        Google Play
      </OtsActionLink>
    </div>
  </article>
);
